/**
 * TRITAL Care® — Recruiting / CEIPAL constants
 *
 * Shared between /careers, /careers/jobs, /clinicians (and nowhere else).
 * NEVER imported by /shiftbridge/* — the PRN marketplace is fully separate.
 */

export const CEIPAL_SUBMIT_RESUME_URL =
  "https://candidateportal.ceipal.com/submit-resume/ilwtsS9bbr0KkvW3uG4Nl4CBgxvcW0BKmU3Y4AbYZxk/ryEsMhqQGqYKbTJWuw87PMhCcAScauhxLnq_lRLfXbY";

export const RECRUITER_PHONE       = "+18323441525";
export const RECRUITER_PHONE_HUMAN = "(832) 344-1525";
export const RECRUITER_EMAIL       = "careers@tritalcare.com";

// Aliases used by /workforce-os components & chatbot.
export const SUBMIT_RESUME_URL  = CEIPAL_SUBMIT_RESUME_URL;
export const RECRUITER_SMS_TEL  = RECRUITER_PHONE;
export const JOBS_PAGE_URL      = "/careers/jobs";
